export type TOAuthProvider = "google";

export type TOAuthProfile = {
  provider: TOAuthProvider;
  email: string;
  name: string;
  picture?: string; // Optional, used for providers like Google
};
